'use client'
import { i18n, i18nInit, IPageScrollPosition, StorePageContext, StorePageDynamicContext, toProxy, watchUpdates, storeUtils } from "@fanfanlo";
import { useRouter } from "next/router";
import { PropsWithChildren, useEffect } from "react";
import { I18nextProvider } from "react-i18next";


i18nInit()

export function AppShell({ children }: PropsWithChildren) {
  const router = useRouter();
  const scrollKey = 'scrollPositionInfo'
  const href = window.location.href.split("#")[0]
  const dynamicKey = `dynamic-${href}`
  const s = storeUtils.namespace(dynamicKey);
  let o: Record<string, unknown>|undefined = s.read(dynamicKey)
  if (!o) {
    o = {}
    s.write(dynamicKey, o)
  }
  o = toProxy(o)
  useEffect(() => {

    router.beforePopState((state) => {
      s.clearAll()
      return true
    })
  })
  useEffect(() => {
    s.write(dynamicKey, o)
    return watchUpdates(o, () => {
      s.write(dynamicKey, o)
    })
  }, [])
  useEffect(() => {
    const info = (s.read(scrollKey) || { x: 0, y: 0 }) as IPageScrollPosition
    // console.log('app shell scroll info info = ', info)
    if (info.x == 0 && info.y == 0) {
      listenScroll()
    } else {
      window.requestAnimationFrame(() => {
        window.scrollTo(info.x, info.y)
        listenScroll()
      })
    }
    function onScroll(e: Event) {
      // console.log('app shell on scroll', { x: window.scrollX, y: window.scrollY })
      s.write(scrollKey, { x: window.scrollX, y: window.scrollY })
    }
    function listenScroll() {
      window.addEventListener('scroll', onScroll)
    }

    function unsub() {
      window.removeEventListener('scroll', onScroll)
    }
    return unsub
  });
  return (
    <StorePageContext value={s}>
      <StorePageDynamicContext value={o}>

        <I18nextProvider i18n={i18n}>
          {children}
        </I18nextProvider>
      </StorePageDynamicContext>
    </StorePageContext>
  )
}